/* Visar ordet som håller på att skrivas. Trycker man på knappen så anropas click-funktion i parent. */
import React from "react";
import Button from 'react-bootstrap/Button';

class WritingWord extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            style: {
                color: "white",
                backgroundColor: "grey",
                padding: "10px",
                fontFamily: "Arial",
                width: "100%",
                fontSize: "1.5em",
                borderRadius: "10px"
            }
        };
    };

    render() {
        return (
            <Button
                style={{
                    ...this.state.style,
                    background: this.props.centerletter_pressed ? "#00a0a0" : "grey"
                }}
                onClick={this.props.onClick} >
                &nbsp;
                {this.props.word.toUpperCase()}
            </Button >
        );
    }
}

export default WritingWord;